module.exports = __webpack_public_path__ + "img/donante-rendichicas.61c1e411.png";